module.exports = __webpack_public_path__ + "img/16581249_L.7341bfc6.png";